import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { store } from '../src/features/Utils/Store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Router, Switch } from 'react-router-dom';
import {history} from'../src/history';

  ReactDOM.render(
  <Provider store={store}>
     <Router history={history}>
        <App userContact={false}/>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
